module.exports = __webpack_public_path__ + "img/Karpicko_tlo.b619ffd4.png";